import React, { ButtonHTMLAttributes, FC } from "react";
import { useRouter } from "next/router";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import { useLightboxState } from "yet-another-react-lightbox";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  filenames: string[];
}

const FrameButton: FC<ButtonProps> = ({ filenames, children, ...rest }) => {
  const router = useRouter();
  const { currentIndex } = useLightboxState();

  const handleClick = (key: string) => {
    const queryParams = new URLSearchParams();
    // Add the 'artFileName' parameter to the query
    queryParams.append("artFileName", key);
    // Construct the new URL with the query parameters
    const newUrl = `/frame?${queryParams.toString()}`;
    router.push(newUrl);
  };

  return (
    <button
      type="button"
      id="frame"
      onClick={() => handleClick(filenames[currentIndex])}
      {...rest}
      className="frame-button"
    >
      {children}
      <PhotoLibraryIcon className="FrameButton" />
      <span className="tooltip">Click to Frame</span>
      <style>{`
        .FrameButton {
          color: black;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .FrameButton:hover {
          color: #D3D3D3;
        }

        .frame-button {
          position: relative; /* Add relative positioning */
          color: black;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          padding-top: 10px;
          padding-bottom: 10px;
          padding-right: 15px;
          padding-left: 15px;
        }
        
        @media (min-width: 600px) {
          .FrameButton {
            height: 36px;
            width: 36px;
            color: black;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .frame-button {
            padding-top: 10px;
            padding-bottom: 10px;
            padding-right: 15px;
            padding-left: 15px;
          }
        }

        .tooltip {
          position: absolute;
          bottom: 50px;
          left: 50%;
          transform: translateX(-50%);
          background-color: rgba(0, 0, 0, 0.7);
          color: #D3D3D3;
          padding: 5px;
          border-radius: 4px;
          font-size: 14px;
          white-space: nowrap; /* Prevent tooltip text from wrapping */
          width: auto; /* Adjust the width as needed */
          min-width: 100px; /* Set a minimum width to avoid being too narrow */
          text-align: center; /* Center the text horizontally */
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s, visibility 0.3s;
        }

        .frame-button:hover .tooltip {
          opacity: 1;
          visibility: visible;
        }

      `}</style>
    </button>
  );
};

export default FrameButton;
